import type React from 'react';

import ChangePassword from '@/components/organism/Settings/ChangePassword/ChangePassword.container';

function SettingsPage(): React.JSX.Element {
  return (
    <div className="flex justify-center p-6">
      <ChangePassword />
    </div>
  );
}

export default SettingsPage;
